module.exports = __webpack_public_path__ + "static/media/cyclelogos_odometer.390a05eb.svg";